import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {DropdownOption} from "../../../../../../models/dropdown-option.model";
import * as Validation from "../../../../../shared/constants/validation.constants";
import {FormControl, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {Router} from "@angular/router";
import {CommonService} from "../../../../../shared/services/common.service";
import { FetchGroupTypeFilterRequest, FetchStatusFilterRequest } from "../../../core/admin-groups-list.actions";
import { groupTypeFilter, statusFilter } from "../../../core/admin-groups-list.selectors";
import { AdminGroupListService } from "../../../services/admin-group-list.service";

@Component({
  selector: 'app-group-information-filter',
  templateUrl: './group-information-filter.component.html',
  styleUrls: ['./group-information-filter.component.css']
})
export class GroupInformationFilterComponent implements OnInit, OnDestroy {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  loading: boolean = false;
  statusFilterList: DropdownOption[] = [];
  groupTypeFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;

  errorMessageMap = {
    'status': {
      required: 'This field is required.'
    },
    'type': {
      required: 'This field is required.'
    },
    'searchText': {
      required: 'This field is required.'
    }
  }

  form = new FormGroup({
    status: new FormControl({value: null, disabled: false}),
    type: new FormControl({value: null, disabled: false}),
    searchText: new FormControl({value: null, disabled: false}),
  })

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private adminGroupListService: AdminGroupListService
  ) {
    this.store.dispatch(FetchStatusFilterRequest());
    this.store.dispatch(FetchGroupTypeFilterRequest());
  }

  ngOnInit() {
    this.store.select(statusFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.loading = data.loading;
        this.statusFilterList = data.list;
      });

    this.store.select(groupTypeFilter)
    .pipe(takeUntil(this.OnDestroy))
         .subscribe((data) => {
      this.loading = data.loading;
      this.groupTypeFilterList = data.list;
    });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const {status, type, searchText} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const payload = {
      type,
      status,
      searchText
    };
    this.adminGroupListService.onGroupFilterChange.next(payload);
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
